<template>
  <div class="modal-window large split active" id="print-contract">
    <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <form @submit.prevent="handleSubmit">
        <div class="grid-x split">
          <div class="cell large-6 flex-column">
            <div class="modal-window-header gray">
              <div class="modal-window-heading">
                <h3 class="icon-heading small">
                  <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg></span>
                  <span class="icon-heading-title">
                    <span class="title">Skriv ut / send besiktigelsesrapport</span>
                  </span>
                </h3>
              </div>
            </div>

            <div class="modal-window-body">
              <fieldset>
                <TheAutoCompleteInputButton
                  containerClassName="cell medium-9"
                  v-model.trim="emailData.to_name"
                  name="Kunde"
                  required
                  v-validate="'required|min:1'"
                  :placeholder="'Velg kunde...'"
                  :label="'Send til kunde: ' + (emailData.to_mail || '-')"
                  :onInputCallback="onKundeSearchInput"
                  :onSelectCallback="onKundeSearchSelected"
                  :onResetCallback="onKundeSearchReset"
                  :disabled="!pdfSource"
                  :style="{ opacity: pdfSource ? 1 : 0.3 }"
                  >
                  <div slot="item" slot-scope="props">
                    <strong>{{props.item.Kundenr}}</strong> {{props.item.full_name}} ({{props.item.Email || 'savner e-post'}})
                  </div>
                </TheAutoCompleteInputButton>
                <div class="grid-x grid-padding-x" :style="{ opacity: pdfSource ? 1 : 0.3 }">
                  <!-- <TheTextInput v-model.trim="emailData.to_name" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker'" :placeholder="'Mottaker navn…'" name="email_to_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.to_mail" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Mottaker e-post'" :placeholder="'Mottaker e-post…'" name="email_to_mail" required v-validate="mailRule"/> -->

                  <TheTextInput v-model.trim="emailData.from_name" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender'" :placeholder="'Avsender navn…'" name="email_from_name" required v-validate="nameRule"/>
                  <TheEmailInput v-model.trim="emailData.from_mail" :disabled="!pdfSource" autofill="off" autocomplete="off" containerClassName="cell medium-6" :label="'Avsender e-post'" :placeholder="'Avsender e-post…'" name="email_from_mail" required v-validate="mailRule"/>

                  <TheSwitchInput v-model="emailData.send_bcc" containerClassName="cell" :disabled="!pdfSource" :small="true" labelTrue="Send kopi til avsender" labelFalse="Send kopi til avsender" :trueValue="true" :falseValue="false"/>

                  <TheTextInput v-model.trim="emailData.subject" :disabled="!pdfSource" containerClassName="cell medium-12" :label="'Emne'" :placeholder="'Emne…'" name="email_subject" required v-validate="subjectRule"/>
                  <TheTextArea v-model="emailData.content" :disabled="!pdfSource" containerClassName="cell medium-12" :label="'Tekst'" :placeholder="'E-post tekst…'" name="email_content"  :rows="3" required v-validate="contentRule"/>
                </div>
              </fieldset>
            </div>

            <div class="modal-window-footer">
              <div class="grid-x">
                <div class="cell align-right">
                  <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
                  <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

                  <template v-if="pdfSource && canSendToKunde">
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="emailButtonClick()" class="button primary submit large">Send til kunde</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Sender til kunde...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Send til kunde</a>
                  </template>
                  <template v-else-if="pdfSource">
                    <a href="javascript:;" class="button primary submit large" disabled>Send til kunde</a>
                  </template>
                  <template v-else>
                    <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Opprett PDF</a>
                    <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Oppretter PDF...<span class="loader-spinner"></span></a>
                    <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Opprett PDF</a>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-6 flex-column">
            <div class="modal-window-body no-padding">
              <div class="iframe-container pdf">
                <iframe v-if="pdfSource" id="pdfFrame" name="pdfFrame" frameborder="0" marginwidth="0" marginheight="0" scrolling="no" :src="pdfSource + '#view=FitH&toolbar=1'"></iframe>
                <TheEmptyList v-if="!pdfSource && !$store.getters.isFormProcessing" :title="'Opprett Besiktigelsesrapport'" :message="'Trykk på Oprett PDF for å se forhåndsvisning og skrive ut besiktigelsesrapport'" :large="false" :icon="'button-glyph-contract'"/>
                <TheLoader :active="!pdfSource && $store.getters.isFormProcessing"/>
              </div>
            </div>
          </div>
        </div>

        <a v-if="!pdfSource" href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
          <span>Lukk</span>
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
        </a>
      </form>
    </overlay-scrollbars>
  </div>
</template>

<script>
import KundeService from '@/services/KundeService'
import ObjektService from '@/services/ObjektService'
import TheAutoCompleteInputButton from '../Inputs/TheAutoCompleteInputButton'

export default {
  name: 'KundeKontraktObjektBesiktelseModal',
  components: {
    TheAutoCompleteInputButton
  },
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      printAndSendEmail: false,
      emailData: {},
      pdfSource: false
    }
  },
  created () {
    this.setFormLoading(false)

    this.setupEmailData()
    this.handleSubmit()
  },
  mounted () {
    window.jQuery('.modal-window-body').attr('tabindex', -1).css({outline: 'none'}).focus()
  },
  computed: {
    nameRule: function () {
      return this.pdfSource ? 'required|max:100' : ''
    },
    mailRule: function () {
      return this.pdfSource ? 'required|email' : ''
    },
    subjectRule: function () {
      return this.pdfSource ? 'required|max:50' : ''
    },
    contentRule: function () {
      return this.pdfSource ? 'required' : ''
    },
    canSendToKunde: function () {
      return this.pdfSource && this.emailData.to_mail
    }
  },
  methods: {
    onKundeSearchReset: function () {
      this.$set(this.emailData, 'to_kundenr', null)
      this.$set(this.emailData, 'to_name', null)
      this.$set(this.emailData, 'to_mail', null)
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      if (item) {
        this.$set(this.emailData, 'to_kundenr', item.Kundenr)
        this.$set(this.emailData, 'to_name', item.full_name)
        this.$set(this.emailData, 'to_mail', item.Email || null)
      } else {
        this.$set(this.emailData, 'to_kundenr', null)
        this.$set(this.emailData, 'to_name', null)
        this.$set(this.emailData, 'to_mail', null)
      }
    },
    setupEmailData: function () {
      let temp = {}

      temp.send_bcc = localStorage.sendBccBesiktPdf === 'true' || localStorage.sendBccBesiktPdf === true

      if (this._.has(this.objekt, 'kontrakt.mottaker.Email')) {
        temp.from_mail = this.objekt.kontrakt.mottaker.Email
        temp.from_name = this._.has(this.objekt, 'kontrakt.mottaker.full_name') ? this.objekt.kontrakt.mottaker.full_name : ''
      } else {
        temp.from_mail = this.$store.getters.getUser.Email || ''
        temp.from_name = this.$store.getters.getUser.full_name || ''
      }

      temp.subject = 'Blomqvist besiktigelsesrapport #' + this.objekt.Objektnr
      temp.content = `Kjære kunde
Vedlagt finner du besiktigelsesrapport for objekt #` + this.objekt.Objektnr + `

Vennlig hilsen
` + (temp.from_name ? temp.from_name : 'Kontraktsansvarlig') + `
      `

      this.$set(this, 'emailData', temp)
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.printAndSendEmail = false

      this.handleSubmit()
    },
    emailButtonClick: function () {
      this.printAndSendEmail = true

      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      if (this.emailData.content) {
        this.emailData.content = this.emailData.content.trim()
      }

      if (this.pdfSource) {
        // Validate form
        this.$validator.validateAll()
          .then((result) => {
            if (!result) {
              // Validation Failed
              this.setFormProcessing(false)
              this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
            } else {
              this.createPdf()
            }
          })
      } else {
        // No validation - as just create for preview
        this.createPdf()
      }
    },
    createPdf: function () {
      const vm = this

      let post = {
        email: this.printAndSendEmail ? this.emailData : null
      }

      ObjektService.createBesiktPdf(this.objekt.Objektid, post)
        .then(response => {
          let url = process.env.VUE_APP_AVANTI_API_URL + response.data

          this.pdfSource = url

          if (this.printAndSendEmail) {
            localStorage.sendBccBesiktPdf = this.emailData.send_bcc

            this.$helpers.showSuccessAlert('Besiktigelsesrapport har blitt sendt til kunde')

            // Reload objekthistory
            vm.$store.dispatch('objekthistory/load', {
              Kundenr: vm.objekt.innlevav.Kundenr,
              Kontraktnr: vm.objekt.Kontraktnr,
              Objektid: vm.objekt.Objektid
            })

            setTimeout(function () {
              vm.$emit('close')
            }, 2500)
          }
        })
        .catch((error) => {
          console.log('Error')
          console.log(error)
          if (this.printAndSendEmail) {
            this.$helpers.showErrorAlert('Feil', 'Kan ikke sende til kunde.')
          } else {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke opprette PDF')
          }
        })
        .then(() => {
          this.setFormProcessing(false)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektBesiktelseModal.vue